import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const SelectSearchContainer = styled.div`
  width: 224px;
  position: relative;

  .select-search, .select-search__value {
    height: 50px;
  }

  .select-search__input {
    height: 48px;
    padding-top: 14px;
    padding-left: 15px;
    padding-right: 15px;
  }

  .select-search__input::placeholder {
    font-size: 12px;
    color: ${colors.GreyInputPlaceholder};
  }

  .select-search__value {
    border-radius: 5px;
    border: 0.7px solid ${colors.GreyInputBorder};
    overflow: hidden;
    background-color: ${colors.bg['white-0']};
  }

  .select-search__options {
    margin: 0;
  }

  .select-search__select {
    border-radius: 0 3px 3px !important;
  }

  .select-search__row {
    border-top: 0;
  }

  .select-search__option {
    color: ${colors.Grey300};
  }

  .select-search__option.is-selected {
    color: ${colors.text['white-0']};
  }

  .select-search__option.is-highlighted, .select-search__option:not(.is-selected):hover {
    background-color: ${colors.Grey050};
  }

  .select-search__value::after {
    transition: transform 200ms ease;
    top: calc(50% - 8px);
  }

  .select-search.has-focus {
    .select-search__value::after {
      top: calc(50% - 4px);
      transform: rotate(-136deg);
      transform-origin: center;
    }
  }
`;

export const Label = styled.span`
  z-index: 2;
  position: absolute;
  top: 6px;
  transition: all 0.2s;
  margin-left: 17px;
  margin-right: 16px;
  color: ${colors.Blue700};
  font-size: 12px;
  font-weight: bold;
`;
